import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react'; // icons for toggle
import React from 'react';
import { Input } from './Input';

const PasswordInput = ({ ...props }: React.InputHTMLAttributes<HTMLInputElement>) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="relative">
      <Input
        type={showPassword ? 'text' : 'password'}
        {...props}
        className="pr-10"
      />
      <button
        type="button"
        className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700"
        onClick={() => setShowPassword(prev => !prev)}
      >
        {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
};
export default PasswordInput;